import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';
import {
  dateFormat,
  convertDateTimeStringToISODate
} from 'common/helpers/dateHelper';
import { editHold } from 'redux/clubMemberships/actions';

class EditHoldModal extends Component {
  handleEdit = (e) => {
    e.preventDefault();
    const { props } = this;
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const endDate = convertDateTimeStringToISODate(
      dateFormat(yesterday, props.settings),
      '11:59 pm',
      props.settings
    );
    const data = { endDate };
    const successFunction = () => {
      props.onCloseModal();
    };
    props.editHold(props.clubMembershipId, props.holdId, data, successFunction);
  };

  handleClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { onCloseModal } = this.props;
    return (
      <Modal title="Remove Your Club Hold" onCloseModal={onCloseModal}>
        <p>
          To remove your upcoming club hold, please click the remove button
          below.
        </p>
        <div className="c7-form__button-row">
          <a onClick={this.handleClose} className="c7-button-alt">
            Cancel
          </a>
          <button type="button" onClick={this.handleEdit} className="c7-button">
            Remove Hold
          </button>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps, {
  editHold
})(EditHoldModal);
